class CustomDialogTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      const dialog = this.nextElementSibling;
      if (dialog && dialog.tagName === 'CUSTOM-DIALOG') {
        dialog.setAttribute('open', '');
        const productInfoContainer = dialog.closest('.product__info-wrapper');
        if (productInfoContainer) {
          productInfoContainer.style.zIndex = '999';
        }
        document.body.style.overflow = 'hidden';
      }
    });
  }
}

class CustomDialog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 使用 querySelectorAll 查找所有匹配的关闭按钮
    const closeButtons = this.querySelectorAll('.t4s-close-overlay, .custom-dialog__close');
    if (closeButtons.length) {
      closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', () => {
          this.removeAttribute('open');
          const productInfoContainer = this.closest('.product__info-wrapper');
          if (productInfoContainer) {
            productInfoContainer.style.zIndex = '';
          }
          document.body.style.overflow = '';
        });
      });
    }
  }
}

customElements.define('custom-dialog-trigger', CustomDialogTrigger);
customElements.define('custom-dialog', CustomDialog);
